import * as monitoringActions from '../store/monitoring/actions'
import * as modalActions from '../store/modal/actions'
import {connect} from 'react-redux'
import MonitoringPanel from '../components/monitoring-page/monitoring-panel'

function mapStateToProps (state) {
  return {
    ...state.monitoring,
    ...state.modal,
    countryList: state.app.accessCountries.monitoring,
    countryLoader: state.app.countryLoader,
  }
}

export default connect(mapStateToProps, {...monitoringActions, ...modalActions})(MonitoringPanel)



// WEBPACK FOOTER //
// ./src/containers/monitoring-panel-container.js